// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/Card/Card.less
// module id = 190
// module chunks = 2